import { axios } from 'libs';

const resource = '/indicadores';

export const getProcessosLocais = ids => {
  return axios.post(`${resource}/processos-locais`, ids);
};
